import api from "./axios";

export const getChatThreadsApi = async (params = {}) => {
  const { search = "", type, list_type, page = 1, limit = 10 } = params;

  const queryParams = new URLSearchParams();

  if (search) queryParams.append("search", search);
  if (type) queryParams.append("type", type);

  if (Array.isArray(list_type) && list_type.length > 0) {
    queryParams.append("list_type", JSON.stringify(list_type));
  }

  queryParams.append("page", page);
  queryParams.append("limit", limit);

  const { data } = await api.get(
    `chat/chat-threads/?${queryParams.toString()}`
  );

  if (!data.success)
    throw new Error(data.message || "Failed to load chat threads");

  return data.data;
};
